import React from 'react';

import { OgAssist as AgentChatSDKOgAssist } from '@opengov/agents-browser-sdk';
import { useNavAuth } from '../ContextSwitcher/Context/NavAuthProvider';
import { useNavBarProps } from '../TopLevelNavigation/NavBarPropsContext';
import { useEntity } from './Context/EntityContext';

export const OgAssist: React.FC = () => {
  const { entityUUID, loading, loadingError } = useEntity();
  const { authBearerToken, getAccessToken } = useNavAuth();
  const { unstable_ogAgentOptions } = useNavBarProps();
  const {
    agentsBaseUrl,
    drawerPortalTargetRef,
    onDrawerToggle,
    applicationContext,
    requestDrawerOpen,
    clientTools,
    welcomeMessage,
    welcomeSuggestions
  } = unstable_ogAgentOptions ?? {};

  const sdkProps = {
    authBearerToken,
    getAccessToken,
    entityID: entityUUID,
    baseURL: agentsBaseUrl ?? window.location.origin,
    loading,
    error: loadingError,
    errorMessage: 'Error loading entity information',
    portalTargetRef: drawerPortalTargetRef,
    onOpenChange: onDrawerToggle,
    applicationContext,
    clientTools,
    welcomeMessage,
    welcomeSuggestions,
    defaultOpen: requestDrawerOpen
  };

  return (
    <AgentChatSDKOgAssist
      // Key ensures remount when host context changes so the drawer closes when requestDrawerOpen becomes false (e.g. user leaves the page).
      key={String(requestDrawerOpen)}
      {...(sdkProps as React.ComponentProps<typeof AgentChatSDKOgAssist>)}
    />
  );
};
